/**
 * @generated SignedSource<<8b390d441504b2febf05d9fdd02378c2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PriceStructure = "CUSTOMIZATION_PRICE" | "FINAL_PRICE" | "SEPARATED_PRICES";
export type PricingGroupInput = {
  description?: NullableValueInputOfStringInput | null;
  id?: string | null;
  infoPricingText?: NullableValueInputOfStringInput | null;
  priceDescriptionEnabled?: NullableValueInputOfNullableOfBooleanInput | null;
  priceStructure?: NullableValueInputOfNullableOfPriceStructureInput | null;
  pricingName?: ValueInputOfStringInput | null;
  printTypes?: NullableValueInputOfListOfInt64Input | null;
  products?: NullableValueInputOfListOfInt64Input | null;
  quantityAsUnit?: NullableValueInputOfNullableOfBooleanInput | null;
  rules?: NullableValueInputOfListOfPricingRuleInput | null;
  showDetailedPrice?: NullableValueInputOfNullableOfBooleanInput | null;
};
export type ValueInputOfStringInput = {
  value?: string | null;
};
export type NullableValueInputOfStringInput = {
  value?: string | null;
};
export type NullableValueInputOfNullableOfBooleanInput = {
  value?: boolean | null;
};
export type NullableValueInputOfNullableOfPriceStructureInput = {
  value?: PriceStructure | null;
};
export type NullableValueInputOfListOfPricingRuleInput = {
  value?: ReadonlyArray<PricingRuleInput | null> | null;
};
export type PricingRuleInput = {
  allMatchType?: ValueInputOfBooleanInput | null;
  conditions?: NullableValueInputOfListOfPricingRuleConditionInput | null;
  elementID?: ValueInputOfInt16Input | null;
  elementTitle?: ValueInputOfStringInput | null;
  isSetupPrice?: ValueInputOfBooleanInput | null;
  priceType?: ValueInputOfInt16Input | null;
  propertyID?: ValueInputOfInt16Input | null;
  ruleID?: number | null;
  simplified?: ValueInputOfBooleanInput | null;
  targets?: NullableValueInputOfListOfPricingRuleTargetInput | null;
};
export type ValueInputOfInt16Input = {
  value: number;
};
export type ValueInputOfBooleanInput = {
  value: boolean;
};
export type NullableValueInputOfListOfPricingRuleConditionInput = {
  value?: ReadonlyArray<PricingRuleConditionInput | null> | null;
};
export type PricingRuleConditionInput = {
  conditionID?: number | null;
  formula?: ValueInputOfStringInput | null;
  position?: ValueInputOfInt16Input | null;
  priceToAdd?: ValueInputOfDecimalInput | null;
  quantity?: ValueInputOfInt16Input | null;
};
export type ValueInputOfDecimalInput = {
  value: number;
};
export type NullableValueInputOfListOfPricingRuleTargetInput = {
  value?: ReadonlyArray<PricingRuleTargetInput | null> | null;
};
export type PricingRuleTargetInput = {
  area?: ValueInputOfStringInput | null;
  color?: ValueInputOfStringInput | null;
  side?: ValueInputOfStringInput | null;
  targetID?: number | null;
};
export type NullableValueInputOfListOfInt64Input = {
  value?: ReadonlyArray<number> | null;
};
export type pricingRuleEditor_UpdatePricingMutation$variables = {
  input: PricingGroupInput;
};
export type pricingRuleEditor_UpdatePricingMutation$data = {
  readonly updatePricing: {
    readonly pricingGroup: {
      readonly id: string;
    } | null;
  };
};
export type pricingRuleEditor_UpdatePricingMutation = {
  response: pricingRuleEditor_UpdatePricingMutation$data;
  variables: pricingRuleEditor_UpdatePricingMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PricingGroupOutput",
    "kind": "LinkedField",
    "name": "updatePricing",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PricingGroup",
        "kind": "LinkedField",
        "name": "pricingGroup",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "pricingRuleEditor_UpdatePricingMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "pricingRuleEditor_UpdatePricingMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1cc6600a3f9333642e84d3e1acfecc01",
    "id": null,
    "metadata": {},
    "name": "pricingRuleEditor_UpdatePricingMutation",
    "operationKind": "mutation",
    "text": "mutation pricingRuleEditor_UpdatePricingMutation(\n  $input: PricingGroupInput!\n) {\n  updatePricing(input: $input) {\n    pricingGroup {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "abeb158aebe414ce5e1ebcf9b1c8cc80";

export default node;
